import { render } from "./XIconSolidAt.vue?vue&type=template&id=f00c6c6c"
import script from "./XIconSolidAt.vue?vue&type=script&lang=js"
export * from "./XIconSolidAt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidAt.vue"]])

export default __exports__